import { useQuery } from "@tanstack/react-query";
import { ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateFull } from "@/lib/format";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tag } from "@/components/common/StatusChip";

export function DeflectedDialog({ channel, onOpenChange }) {
  const { data: rows = [], isLoading } = useQuery({ queryKey: ["deflections", channel.id], queryFn: () => api.get(`/channels/${channel.id}/deflections`).then((r) => r.data) });
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[88vh] max-w-3xl overflow-auto" data-testid="deflected-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldAlert className="h-4 w-4 text-amber-500" /> Turned away from {channel.name}</DialogTitle>
          <DialogDescription>Emails that arrived while the channel was swamped, or from senders not on its allowed list. The sender received the channel's message and no ticket was created. Nothing is deleted.</DialogDescription>
        </DialogHeader>
        {isLoading && <div className="p-4 text-xs text-muted-foreground">Loading…</div>}
        {!isLoading && rows.length === 0 && <div className="p-4 text-xs text-muted-foreground" data-testid="deflected-empty">No emails have been turned away yet.</div>}
        <ul className="divide-y divide-border border border-border">
          {rows.map((r) => (
            <li key={r.id} className="space-y-1 px-3 py-2 text-xs" data-testid={`deflected-row-${r.id}`}>
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-semibold">{r.subject}</span>
                <Tag tone={r.reason === "blocked_sender" ? "cyan" : "amber"} data-testid={`deflected-reason-${r.id}`}>{r.reason === "blocked_sender" ? (r.ticket_number ? `blocked reply · ${r.ticket_number}` : "sender not allowed") : "swamped"}</Tag>
                <Tag tone={r.reply_status === "sent" ? "emerald" : r.reply_status === "queued" ? "amber" : "neutral"}>reply {r.reply_status}</Tag>
                <span className="mono ml-auto text-[11px] text-muted-foreground">{fmtDateFull(r.at)}</span>
              </div>
              <div className="mono text-[11px] text-muted-foreground">{r.from_name ? `${r.from_name} <${r.from_email}>` : r.from_email}{r.reason !== "blocked_sender" ? ` · ${r.open_count} open ≥ limit ${r.limit}` : ""}{r.attachment_names?.length ? ` · ${r.attachment_names.length} attachment(s) not stored` : ""}</div>
              {r.preview && <p className="line-clamp-2 text-muted-foreground">{r.preview}</p>}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
